module.exports = __webpack_public_path__ + "logo-white.png";